module.exports = __webpack_public_path__ + "img/fake_en.55e0206b.svg";